import { FC } from 'react';
import { BoxProps } from '@mui/material';

import { Image } from '../Media/Image';


export const DirigoShortLogo: FC<BoxProps<'img'>> = (props) => {
  return (
    <Image
      display="block"
      margin="0 auto"
      width="auto"
      src="/assets/dirigo_short.png" alt="Dirigo Logo"
      {...props}
    />
  );
};
